<template>
    <a-modal
        centered
        title="拒绝申请"
        :visible="visible"
        @ok="on_ok"
        @cancel="on_cancel"
        :width="360"
        :confirmLoading="submitting"
        :after-close="after_close"
    >
        <a-form-model :model="form" :rules="rules" ref="_form">
            <a-form-model-item label="拒绝原因" prop="reject_msg">
                <a-textarea v-model="form.reject_msg" :auto-size="{ minRows: 4, maxRows: 10 }"></a-textarea>
            </a-form-model-item>
        </a-form-model>
    </a-modal>
</template>
<script>
    let init_form = {
        reject_msg: null,
        status: "-1",
        action: "reject",
    };
    export default {
        props: {
            visible: false,
            record: null,
            callback: null,
            scope: null,
        },
        data() {
            return {
                submitting: false,
                form: null,
                rules: {
                    reject_msg: [
                        {
                            required: true,
                            trigger: ["change", "blur"],
                            message: "填写拒绝原因",
                        },
                    ],
                },
            };
        },
        watch: {
            visible(e) {
                if (e && this.record) {
                    this.form.object_no = this.record.object_no;
                    this.form.scope = this.scope;
                }
            },
        },
        created() {
            this.form = JSON.parse(JSON.stringify(init_form));
        },
        methods: {
            on_ok() {
                this.$refs["_form"].validate((valid) => {
                    if (valid) {
                        this.submitting = true;
                        this.$http
                            .post(`/apply/audit/review`, this.form)
                            .then((res) => {
                                if (res.success) {
                                    this.$message.success(res.message);
                                    this.on_cancel();
                                    if (this.callback) {
                                        this.callback();
                                    }
                                } else {
                                    this.$error({
                                        title: "失败",
                                        centered: true,
                                        content: res.message,
                                    });
                                }
                            })
                            .catch(() => {})
                            .then(() => {
                                this.submitting = false;
                            });
                    } else {
                        this.$message.error("请检查并填写完需要录入的内容");
                        return false;
                    }
                });
            },
            after_close() {
                this.form.reject_msg = null;

                this.$refs["_form"].resetFields();
            },
            on_cancel() {
                this.$emit("close");
            },
        },
    };
</script>
